module.exports = __webpack_public_path__ + "static/media/business.9268dacf.svg";